









































































































































































































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  BaseCubeMember,
  TCubeDimension,
  TCubeMeasure,
} from '@cubejs-client/core';
import BaseMixin from '@/components/mixins/base';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import DxList from 'devextreme-vue/list';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxButton from 'devextreme-vue/button';
import DxTreeView from 'devextreme-vue/tree-view';
import DxValidator, { DxRequiredRule, DxStringLengthRule } from 'devextreme-vue/validator';
import DxValidationGroup from 'devextreme-vue/validation-group';
import {
  apiService,
  customerService,
} from '@/container';
import ChartRender from '@/components/charts/ChartRender.vue';
import FilterBuilder from './filter-builder.vue';
import TimeDimensionSelection from './time-dimension-selection.vue';
import { cloneDeep, first, isEqual, isNil, isString, merge, sortBy, tail, intersection, isArray } from 'lodash';
import {
  ValidatedQuery,
  ISortingFieldComboboxValue,
  SortingDirection,
  ChartType
} from './types';
import { ChartConfigVersion, getDefaultChartConfig, getDefaultLatestVersionChartConfig, IChartConfig,
	pushAxisDimensionSafelyInConfig, pushLegendDimensionSafelyInConfig, pushMeasuresDimensionSafelyInConfig,
	removeDimensionFromAxisIfPresent
} from '@/components/charts/resultSetTransform';

@Component({
  components: {
    DxDropDownBox, DxTreeView,
    DxSelectBox,
    ChartRender,
    DxValidationGroup,
    DxTextBox,
    DxValidator,
    DxStringLengthRule,
    DxRequiredRule,
    DxList,
    DxButton,
    FilterBuilder,
    TimeDimensionSelection
  }
})
export default class ChartCreateFields extends BaseMixin {
  @Prop({ type: Array, required: true }) availableDimensions!: TCubeDimension[]
  @Prop({ type: Array, required: true }) availableMeasures!: TCubeMeasure[]
  @Prop({ type: Array, required: true }) availableTimeDimensions!: TCubeDimension[]
  @Prop({ type: Array, default: () => [] }) filters!: any[];
  @Prop({ type: Array, default: () => [] }) dimensions!: any[];
  @Prop({ type: Array, default: () => [] }) measures!: any[];
  @Prop({ type: Array, default: () => [] }) timeDimensions!: any[];

	// @Prop({ type: Array, default: () => [] }) axisDimensions!: TCubeDimension[];
	// @Prop({ type: Array, default: () => [] }) legendDimensions!: TCubeDimension[];

	@Prop({ type: Object, default: () => ({}) }) config!: IChartConfig | null;

  @Prop({ type: Function, default: () => () => void 0 }) setFilters!: (cubeFilter: any) => void;
  @Prop({ type: Function, default: () => () => void 0 }) setDimensions!: (dim: any[]) => void;
  @Prop({ type: Function, default: () => () => void 0 }) setMeasures!: (measure: any[]) => void;
  @Prop({ type: Function, default: () => () => void 0 }) setTimeDimensions!: (dim: any[]) => void;
  @Prop({ type: Function, default: () => () => void 0 }) setOrder!: (obj: any) => void;
  @Prop({ type: Boolean }) useWeek!: boolean | null;
  @Prop({ type: Object }) validatedQuery!: ValidatedQuery;
  @Prop({ type: String }) chartType!: any;

	@Prop({ type: Function }) addNewQuery?: () => Promise<void>;
	bindAddNewQuery() {
		this.$emit('update:addNewQuery', this.internalAddNewQuery);
	}

	queries: any[] = [{ measure: [], timeDimension: [], filter: [] }];
	async internalAddNewQuery(): Promise<void> {
		this.queries.push({ measure: [], timeDimension: [], filter: [] });
	}
	onRemoveQuery(index) {
		this.queries.splice(index, 1);
	}

  isMeasuresDropDownBoxOpened = false;
  isDimensionsDropDownBoxOpened = false;
  loading = false;
  genericFields: string[] = [];
  selectedFieldForSorting: any = {};
  pie = ChartType.PIE;

	// internalSelectedAxisDimensions: TCubeDimension[] = [];
	// internalSelectedLegendDimensions: TCubeDimension[] = [];
	internalChartConfig: IChartConfig = getDefaultLatestVersionChartConfig();

	userSelectionWatcherAlreadySet = false;

  async created(): Promise<void> {
    var customer = customerService.getCustomer();
    if (customer != null) {
      this.genericFields = await apiService.get('datamart', `genericFieldsByCustomer/${customer}`);
    }

    Vue.prototype.$isweek = false;

    this.$watch(() => this.validatedQuery, (data) => {
			const order = data.order;
      if(!order){
        return;
      }

      const orderKeys = Object.entries<string>(order);

      if(orderKeys.length > 0){
        const [[ key, value ]] = orderKeys;
        const test = this.fieldsForSortingDataSource.find(x => x.key === key && x.value === value)!;
        if(test)
					this.selectedFieldForSorting = test.displayValue;
      }
    }, { immediate: true });

		this.$watch(() => this.config, (config) => {
			if (isNil(config)) {
				this.internalChartConfig = getDefaultChartConfig();
				this.onUserSelectionsChanged(this.userSelections, null);
			}
			else if (!isEqual(config, this.internalChartConfig )){
				this.internalChartConfig = cloneDeep(config);
			}

			if (!this.userSelectionWatcherAlreadySet) {
				this.$watch(() => this.userSelections, this.onUserSelectionsChanged);
				this.userSelectionWatcherAlreadySet = true;
			}
		}, { immediate: true });

		this.$watch(() => this.internalChartConfig, (newChartConfig, oldChartconfig) => {
			if (isEqual(newChartConfig, oldChartconfig))
				return;
			this.$emit('update:config', cloneDeep(newChartConfig));
		});

		// this.$watch(() => ({
		// 	chartType: this.chartType,
		// 	availableDimensionsForAxis: this.availableDimensionsForAxis,
		// 	availableDimensionsForLegend: this.availableDimensionsForLegend
		// } as IStateForLegendAndAxisChange), this.onStateForLegendAndAxisChange);
  }

	mounted() {
		this.bindAddNewQuery();
	}

  groupByGranularity(granularityName) {
    this.$emit('groupByGranularity', granularityName);
  }

  get fieldsForSortingDataSource(): ISortingFieldComboboxValue[] {
    const { measures = [], dimensions = [] } = this.validatedQuery;

		const selectedAxisDimensions = this.internalChartConfig.axisDimensions || [];
		const selectedAxisDimensionsCount = selectedAxisDimensions.length;

		const selectedLegendDimensions = this.internalChartConfig.legendDimensions || [];


		const translate = this.$t;
		const ascResult: ISortingFieldComboboxValue[] = [];
		const descResult: ISortingFieldComboboxValue[] = [];

		const timeDimension = cloneDeep((this.timeDimensions || [])[0]);
		const isNotSelectedTimeDimension = isNil(timeDimension);

		// in next sprints might be removed.
		if (selectedLegendDimensions.length === 0) {
			Array.prototype.push.apply(ascResult, measures.map(sortAscDescription));
			Array.prototype.push.apply(descResult, measures.map(sortDescDescription));
			if (selectedAxisDimensionsCount === 0) {
				Array.prototype.push.apply(ascResult, dimensions.map(sortAscDescription));
				Array.prototype.push.apply(descResult, dimensions.map(sortDescDescription));
			}
			else if (isNotSelectedTimeDimension) {
				const axisDim = first(selectedAxisDimensions)!;
				if (axisDim.type !== 'time') {
					ascResult.push(sortAscDescription(axisDim));
					descResult.push(sortDescDescription(axisDim));
				}
			}
		}
		else {
			const legendDim = first(selectedLegendDimensions)!;
			if (selectedLegendDimensions.every(ld => ld.type !== 'time')) {
        ascResult.push(sortAscDescription(legendDim));
        descResult.push(sortDescDescription(legendDim));
			}
			if (selectedAxisDimensionsCount >= 1) {
				const axisDim = first(selectedAxisDimensions)!;
				if (selectedAxisDimensions.every(ad => ad.type !== 'time')) {
          ascResult.push(sortAscDescription(axisDim));
          descResult.push(sortDescDescription(axisDim));
        }
			}
		}

    // return [
    //   ...measures.map(measure => ({ displayValue: `${this.$t(measure)} ${SortingDirection.ASC.toUpperCase()}`, key: measure, value: SortingDirection.ASC })),
    //   ...dimensions.map(dimension => ({ displayValue: `${this.$t(dimension)} ${SortingDirection.ASC.toUpperCase()}`, key: dimension, value: SortingDirection.ASC })),
    //   ...measures.map(measure => ({ displayValue: `${this.$t(measure)} ${SortingDirection.DESC.toUpperCase()}`, key: measure, value: SortingDirection.DESC })),
    //   ...dimensions.map(dimension => ({ displayValue: `${this.$t(dimension)} ${SortingDirection.DESC.toUpperCase()}`, key: dimension, value: SortingDirection.DESC }))
    // ];
		return [
			...ascResult,
			...descResult
		];

		function sortAscDescription(measureOrDimension: string | TCubeDimension): ISortingFieldComboboxValue {
			let code = measureOrDimension as string;
			if (!_.isString(measureOrDimension))
				code = measureOrDimension.name;
			return {
				displayValue: `${translate(code)} ${SortingDirection.ASC.toUpperCase()}`,
				key: code,
				value: SortingDirection.ASC
			};
		}
		function sortDescDescription(measureOrDimension: string | TCubeDimension) {
			let code = measureOrDimension as string;
			if (!_.isString(measureOrDimension))
				code = measureOrDimension.name;
			return {
				displayValue: `${translate(code)} ${SortingDirection.DESC.toUpperCase()}`,
				key: code,
				value: SortingDirection.DESC
			};
		}
  }

  get genericFieldsDictionary(): Record<string, boolean> {
    const result: Record<string, boolean> = {};
    this.genericFields.forEach(gf => {
      result[gf] = true;
    });
    return result;
  }

	get isAxisAndLegendsSelectionAvailable() {
		return this.chartType === ChartType.BAR || this.chartType === ChartType.LINE || this.chartType === ChartType.AREA;
	}

	get availableDimensionsForAxis() {
		const result = this.dimensions.map(dim => ({
			...dim,
			caption: this.$t(dim.name)
		}));
		if (Array.isArray(this.timeDimensions) && this.timeDimensions.length) {
			const timeDimension = first(this.timeDimensions).dimension;
			result.push({
				...timeDimension,
				caption: this.$t(timeDimension.name)
			});
		}
		return result;
	}
	get axisDimensionsSet() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.axisDimensions))
			return new Set();

		return new Set(this.internalChartConfig.axisDimensions.map(ad => ad.name));
	}
	get selectedDimensionsForDropDownAxis() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.axisDimensions))
			return [];

		return this.internalChartConfig.axisDimensions.map(ad => ad.name);
	}get selectedDimensionsForListAxis() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.axisDimensions))
			return [];

		return this.internalChartConfig.axisDimensions;
	}

	get availableDimensionsForLegend() {
		const result = this.dimensions.map(dim => ({
			...dim,
			caption: this.$t(dim.name)
		}));
		if (Array.isArray(this.timeDimensions) && this.timeDimensions.length) {
			const timeDimension = first(this.timeDimensions).dimension;
			result.push({
				...timeDimension,
				caption: this.$t(timeDimension.name)
			});
		}
		return result;
	}

	get legendDimensionsSet() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.legendDimensions))
			return new Set();

		return new Set(this.internalChartConfig.legendDimensions.map(ld => ld.name));
	}

	get selectedDimensionsForDropDownLegend() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.legendDimensions))
			return [];

		return this.internalChartConfig.legendDimensions.map(ad => ad.name);
	}

	get selectedDimensionsForListLegend() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.legendDimensions))
			return [];

		return this.internalChartConfig.legendDimensions;
	}

  get availableDimensionsFiltered() {
    return this.filterAndMapFields(this.availableDimensions);
  }

  get availableTimeDimensionsFiltered() {
    return this.filterAndMapFields(this.availableTimeDimensions);
  }

  get availableMeasuresFiltered() {
    return this.filterAndMapFields(this.availableMeasures);
  }

  filterAndMapFields(items: BaseCubeMember[]) {
    const toShowList = ['Dim_DataSegregation.companyCode', 'Dim_DataSegregation.companyBusinessName', 'Dim_DataSegregation.siteCode', 'Dim_DataSegregation.siteBusinessName'];

    return sortBy(items
      .filter(d => (!d.name.includes('.gen') && !d.name.startsWith('Dim_DataSegregation'))
        || (d.name.includes('.gen') && this.genericFieldsDictionary[d.name])
        || (d.name.startsWith('Dim_DataSegregation') && toShowList.includes(d.name)))
      .map(d => {
        const caption = this.$t(d.name);
        return {
          ...d,
          caption,
          captionCode: d.name
        };
      }), itm => itm.caption);
  }

  onChangeMeasuresDropDownBoxValue({ addedItems, removedItems }: { addedItems: { name: string }[], removedItems: { name: string }[] }, setMeasures: (names: string[]) => void, mesuarse: { name: string }[], setTimeDimension: any): void {
    if (addedItems.length > 0) {
      setMeasures([...mesuarse.map(x => x.name), ...addedItems.map(x => x.name)]);
    } else if (removedItems.length > 0) {
      const removedNames = removedItems.map(x => x.name);
      setMeasures([...mesuarse.map(x => x.name).filter(x => !removedNames.includes(x))]);
    }
  }

  onChangeDimensionsDropDownBoxValue({ addedItems, removedItems }: { addedItems: { name: string }[], removedItems: { name: string }[] }, setDimentions: (names: string[]) => void, dimentions: { name: string }[]): void {
    if (addedItems.length > 0)
      setDimentions([...dimentions.map(x => x.name), ...addedItems.map(x => x.name)]);
    else if (removedItems.length > 0) {
      const removedNames = removedItems.map(x => x.name);
      setDimentions([...dimentions.map(x => x.name).filter(x => !removedNames.includes(x))]);
    }
  }

  onChangeSortingFieldDropDownBoxValue({ value: selectedValue }: { value: string }): void {
    const selectedItem = this.fieldsForSortingDataSource.find(x => x.displayValue === selectedValue);
    this.setOrder(selectedItem ? {[selectedItem.key]: selectedItem.value} : {});
  }

	onChangeAxisDimensionSelection({ addedItems, removedItems }: { addedItems: TCubeDimension[], removedItems: TCubeDimension[] }) {
		const config = cloneDeep(this.internalChartConfig);
		if (Array.isArray(removedItems) && removedItems.length) {
			const toRemove = new Set(removedItems.map(ri => ri.name));
			config.axisDimensions = config.axisDimensions.filter(cd => !toRemove.has(cd.name));
		}
		if (Array.isArray(addedItems)) {
			Array.prototype.push.apply(config.axisDimensions, addedItems.filter(ai => !this.axisDimensionsSet.has(ai.name)));
			const toRemoveFromLegend = new Set(addedItems.map(ri => ri.name));
			config.legendDimensions = config.legendDimensions.filter(cd => !toRemoveFromLegend.has(cd.name));
		}
		if ((config.version || -1) <= ChartConfigVersion.AxisAndLegends)
			config.version = ChartConfigVersion.AxisAndLegends;
		this.internalChartConfig = config;
	}

	onChangeLegendDimensionSelection({ addedItems, removedItems }: { addedItems: TCubeDimension[], removedItems: TCubeDimension[] }) {
		const config = cloneDeep(this.internalChartConfig);
		if (Array.isArray(removedItems) && removedItems.length) {
			const toRemove = new Set(removedItems.map(ri => ri.name));
			config.legendDimensions = config.legendDimensions.filter(cd => !toRemove.has(cd.name));
		}
		if (Array.isArray(addedItems)) {
			Array.prototype.push.apply(config.legendDimensions, addedItems.filter(ai => !this.legendDimensionsSet.has(ai.name)));
			const toRemoveFromAxis = new Set(addedItems.map(ri => ri.name));
			config.axisDimensions = config.axisDimensions.filter(cd => !toRemoveFromAxis.has(cd.name));
		}
		if ((config.version || -1) <= ChartConfigVersion.AxisAndLegends)
			config.version = ChartConfigVersion.AxisAndLegends;
		this.internalChartConfig = config;
	}

	get userSelections() {
		return {
			measures: this.measures,
			dimensions: this.dimensions,
			timeDimensions: getCleanTimeDimension(this.timeDimensions)
		};

		function getCleanTimeDimension(td) {
			if (isNil(td) || !isArray(td) || td.length === 0)
				return [];

			return td.map(x => {
				if (!isNil(x.dimension) && !isNil(x.dimension.granularities))
					delete x.dimension.granularities;
				return {
					granularity: x.granularity,
					index: x.index,
					...x.dimension
				};
			});
		}
	}

	onUserSelectionsChanged(currentVal, oldVal) {
		const config = cloneDeep(this.internalChartConfig);

		if (isEqual(currentVal, oldVal))
			return;

		const { isDimensionSet, isTimeDimensionSet, isMeasuresSet } = this.parseUserSelection(currentVal, oldVal);
		if (isMeasuresSet) {
			pushMeasuresDimensionSafelyInConfig(config, currentVal.measures);
		}

		if (isDimensionSet) {
			config.selectedDimensions = [...currentVal.dimensions];

			if (isTimeDimensionSet) {
				removeDimensionFromAxisIfPresent(config, currentVal.dimensions);
				pushAxisDimensionSafelyInConfig(config, currentVal.timeDimensions[0]);
				pushLegendDimensionSafelyInConfig(config, currentVal.dimensions);
			} else {
				pushAxisDimensionSafelyInConfig(config, currentVal.dimensions, { clearBeforePush: true });
				pushLegendDimensionSafelyInConfig(config, null, { clearBeforePush: true });
			}
		}

		this.internalChartConfig = config;
	}

	parseUserSelection(currentVal, oldVal) {
		let isTimeDimensionSet = false, isDimensionSet = false, isMeasuresSet = false;

		isDimensionSet = isArrayWithAtLeastOneValue(currentVal.dimensions);
		isTimeDimensionSet = isArrayWithAtLeastOneValue(currentVal.timeDimensions);
		isMeasuresSet = isArrayWithAtLeastOneValue(currentVal.measures);

		return {
			isDimensionSet,
			isTimeDimensionSet,
			isMeasuresSet
		};

		function isArrayWithAtLeastOneValue(objectToCheck) {
			return !isNil(objectToCheck) && isArray(objectToCheck) && objectToCheck.length > 0;
		}
	}
}


